"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var Base_1 = require("./Base");
var plugins_1 = require("./plugins");
var createScript_1 = require("./utils/createScript");
var ALLOWED_METHODS = ["view", "link", "video", "setDataLayer", "setup"];
var Tealium = /** @class */ (function (_super) {
    __extends(Tealium, _super);
    function Tealium() {
        var _this = _super.call(this) || this;
        _this.setup = function (_a) {
            var account = _a.account, profile = _a.profile, environment = _a.environment, defaultLayer = _a.defaultLayer, eventLog = _a.eventLog;
            return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (typeof window.utag !== "undefined") {
                                this.warn("utag already loaded");
                                return [2 /*return*/, Promise.resolve()];
                            }
                            if (!account || !profile) {
                                return [2 /*return*/, Promise.reject("Account and profile are required to load utag")];
                            }
                            this.info("load utag", { account: account, profile: profile, environment: environment });
                            if (defaultLayer) {
                                this.setDataLayer(defaultLayer);
                            }
                            plugins_1.EventLog.init(eventLog || {});
                            return [4 /*yield*/, (0, createScript_1.default)("//tags.tiqcdn.com/utag/".concat(account, "/").concat(profile, "/").concat(environment || "prod", "/utag.js")).catch(function (err) {
                                    _this.error(err);
                                    return Promise.reject("Account and profile are required to load utag");
                                })];
                        case 1:
                            _b.sent();
                            this.setEventsFromQueue();
                            Promise.resolve();
                            return [2 /*return*/];
                    }
                });
            });
        };
        _this.setDataLayer = function (data) {
            _this.defaultLayer = __assign(__assign({}, _this.defaultLayer), data);
        };
        _this.setEventsFromQueue = function () {
            if (!_this.queue.length)
                return;
            _this.info("queue[track]", __spreadArray([], _this.queue, true));
            do {
                var event_1 = _this.queue.shift();
                if (event_1)
                    _this.track(event_1.call_type, event_1);
            } while (_this.queue.length);
        };
        _this.getPlugin = function (input) {
            if (!input)
                return _this.warn("Missing plugin name");
            var name = input.toLowerCase();
            if (name === "eventlog")
                return plugins_1.EventLog;
            if (name === "heartbeat")
                return plugins_1.HeartBeat;
            if (name === "jwmonitor")
                return plugins_1.JwMonitor;
            _this.warn("Plugin '".concat(input, "' not found"));
        };
        _this.push = function (_a) {
            var command = _a[0], data = _a[1];
            if (!ALLOWED_METHODS.includes(command))
                return _this.warn("Unsupported command ".concat(command, "\n Please use one of these methods: ").concat(ALLOWED_METHODS.join(", "), " "));
            _this[command](data);
        };
        _this.name = "Tealium";
        if (typeof window === "undefined")
            return _this;
        if (Array.isArray(window.WXA)) {
            window.WXA.forEach(function (_a) {
                var command = _a[0], data = _a[1];
                if (!ALLOWED_METHODS.includes(command))
                    return _this.warn("Unsupported command ".concat(command, "\n Please use one of these methods: ").concat(ALLOWED_METHODS.join(", "), " "));
                _this[command](data);
            });
        }
        window.WXA = _this;
        return _this;
    }
    return Tealium;
}(Base_1.default));
exports.default = new Tealium();
